<template>
  <baseMap ref="mapRef" class="map" @mounted="mapMounted" />
</template>
<script setup>
  import { defineProps, defineEmits, ref, onMounted } from 'vue'
  import baseMap from '@/components/map/base_map'
  import selectLocation from '@/assets/selectLocation.png'
  import defaultLocation from '@/assets/defaultLocation.png'
  import coordtransform from 'coordtransform'
  const emit = defineEmits(['update:modelValue'])
  const mapRef = ref()
  const selectedPoints = ref(new Set())

  const props = defineProps({
    points: Array, // [{id: 1, lat: 22.744976, lng: 114.524402}, ...]
    modelValue: Array,
    isView: {
      default: true,
    },
  })

  // 设置图标大小
  const defaultIcon = window.L.icon({
    iconUrl: defaultLocation,
    iconSize: [41, 41], // 调整图标大小
    iconAnchor: [20.5, 41], // 底部中心 [宽度的一半, 高度]
  })

  const selectedIcon = window.L.icon({
    iconUrl: selectLocation,
    iconSize: [41, 41], // 调整图标大小
    iconAnchor: [20.5, 41], // 底部中心 [宽度的一半, 高度]
  })

  function mapMounted(map) {
    if (!props.points?.length) return

    // 配置地图工具栏
    map.pm.setLang('zh')

    // 添加点位到地图
    props.points.forEach((point) => {
      const [longitude, latitude] = coordtransform.gcj02towgs84(
        point.lng,
        point.lat
      )
      const marker = window.L.marker([latitude, longitude], {
        icon: defaultIcon,
      }).addTo(map)

      marker.pointId = point.id
      if (props.modelValue.includes(point.id)) {
        selectedPoints.value.add(point.id)
        marker.setIcon(selectedIcon)
      }

      !props.isView &&
        marker.on('click', () => {
          toggleSelection(marker)
        })
    })
  }

  function toggleSelection(marker) {
    if (selectedPoints.value.has(marker.pointId)) {
      selectedPoints.value.delete(marker.pointId)
      marker.setIcon(window.L.icon({ iconUrl: defaultLocation }))
    } else {
      selectedPoints.value.add(marker.pointId)
      marker.setIcon(window.L.icon({ iconUrl: selectLocation }))
    }
    emit('update:modelValue', Array.from(selectedPoints.value))
  }
</script>
<style scoped lang="less">
  .map {
    height: 100% !important;
  }
</style>
